import { Block } from "@chameleoncreator/creator-app";
import { Action, initialState, State, TrackerState } from "store/store";

export const setBlock = (state: State = initialState, { data }: Action): State => {
  const nextState = {
    ...state,
    blocks: { ...state.blocks },
    tracker: { ...state.tracker },
  };
  nextState.blocks[data.id] = data as Block;
  nextState.tracker[data.id] = TrackerState.DIRTY;
  return nextState;
};
